import { useEffect } from 'react';
import { GtmService } from 'tradera/services/google-tagmanager-service';
import { getRecentSearchesLocalStorage } from 'tradera/state/personalisation/helpers';
import {
    SortBy,
    useSearchQuery
} from 'tradera/state/services/touchweb-search-api';

export const useGetLastSearch = (loadingTriggerInView: boolean) => {
    const recentSearches = getRecentSearchesLocalStorage();
    const hasAnyRecentSearches = recentSearches.length > 0;
    const lastSearch = recentSearches[0] ?? {};
    const queryParams = {
        ...lastSearch.queryParams,
        // We always want to sort on newest added to get a more "alive" feeling on the start page.
        // And it would be confusing for the user if they clicked the link to get to all search
        // results if they didn't see the same items on top as they did on the start page.
        sortBy: SortBy.AddedOn
    };

    const { data, isSuccess, ...restProps } = useSearchQuery(queryParams, {
        skip: !loadingTriggerInView || !hasAnyRecentSearches
    });

    useEffect(() => {
        if (isSuccess) {
            GtmService.trackAction(
                'StartPage',
                'lastSearch',
                'number of search results on load',
                data.items.length
            );
        }
    }, [data, isSuccess]);

    return { queryParams, data, isSuccess, ...restProps };
};
